<div class="modal fade" id="unifyViaticosModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">

      <!-- Header -->
      <div class="modal-header border-0 pb-0 position-relative">
        <button type="button" class="btn-close position-absolute end-0 top-0 mt-3 me-3" (click)="close()"></button>
      </div>

      <!-- Body -->
      <div class="modal-body px-4 pt-2 pb-3">
        <h5 class="text-center fw-bold mb-1">Unificar viáticos</h5>
        <p class="text-center text-muted small mb-3">
          ¿Con que servicio compartirá los viáticos el servicio actual?
        </p>

        <!-- Loading -->
        <div *ngIf="isLoading" class="text-center py-5">
          <div class="spinner-border text-primary" role="status"></div>
        </div>

        <!-- Empty (solo cuando no está cargando y no hay datos) -->
        <div *ngIf="!isLoading && rowData.length === 0" class="text-center text-muted py-5">
          No hay servicios disponibles para unificar con el mismo conductor.
        </div>

        <!-- ag-Grid: siempre en el DOM, oculto cuando no hay datos -->
        <ag-grid-angular
          class="ag-theme-alpine unify-grid"
          [style.display]="!isLoading && rowData.length > 0 ? 'block' : 'none'"
          style="width: 100%; height: 220px;"
          [rowData]="rowData"
          [columnDefs]="columnDefs"
          [defaultColDef]="defaultColDef"
          rowSelection="multiple"
          (gridReady)="onGridReady($event)">
        </ag-grid-angular>
      </div>

      <!-- Footer centrado -->
      <div class="modal-footer border-0 justify-content-center gap-3 pb-4">
        <button type="button" class="btn btn-outline-primary unify-btn rounded-pill" (click)="close()">
          Cancelar
        </button>
        <button type="button" class="btn btn-primary unify-btn rounded-pill d-flex align-items-center justify-content-center gap-2"
                (click)="confirm()" [disabled]="selectedCount === 0 || isSaving">
          <span *ngIf="isSaving" class="spinner-border spinner-border-sm"></span>
          <svg *ngIf="!isSaving" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
            <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1 1 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4 4 0 0 1-.128-1.287z"/>
            <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243z"/>
          </svg>
          Unificar viáticos
        </button>
      </div>

    </div>
  </div>
</div>
